export default AdminDashboardPage;
import React, { useEffect } from "react";
import {
  Box,
  Typography,
  Container,
  Paper,
  Grid,
  Card,
  CardContent,
  Avatar,
  Button,
  Stack,
} from "@mui/material";
import { signOut } from "../firebaseSetup";
import useAuth from "../hooks/useAuth";
import Config from "../models/Config";
import PageHeader from "../components/PageHeader";
import { Navigate, useNavigate } from "react-router-dom";

function AdminDashboardPage() {
  // Handler to sign out and redirect to home
  const handleSignOut = async () => {
    await signOut();
    navigate('/');
  };
  const user = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    document.title = `${Config.TAB_PREFIX}Admin Dashboard`;
  }, []);


  // Redirect to admin login if not authenticated or not admin
  if (!user || !user.isAdmin) {
    return <Navigate to="/admin" replace />;
  }

  return (
    <>
      <PageHeader header="Admin Dashboard" />
      <Container maxWidth="sm">
        <Paper elevation={3} sx={{ padding: 4, marginTop: 4 }}>
          <Stack direction="row" spacing={3} alignItems="center" sx={{ mb: 4 }}>
             <Avatar
               src={user.user?.photoURL || ""}
               alt={user.user?.displayName || ""}
               sx={{ width: 80, height: 80 }}
             />
            <Box>
               <Typography variant="h4" gutterBottom>
                 Welcome back, {user.user?.displayName || "Admin"}!
               </Typography>
               <Typography variant="body1" color="text.secondary">
                 {user.user?.email}
               </Typography>
            </Box>
            {/* Removed sign out button */}
          </Stack>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 24, alignItems: 'center' }}>
            <div style={{ width: '100%' }}>
              <Card sx={{ height: "100%" }}>
                <CardContent>
                  <Typography variant="h6" gutterBottom>
                    Shows
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Manage show schedules
                  </Typography>
                  <Button
                    variant="contained"
                    size="small"
                    sx={{ mt: 2 }}
                    onClick={() => navigate('/admin/showManagement')}
                  >
                    Shows
                  </Button>
                </CardContent>
              </Card>
            </div>
            <div style={{ width: '100%' }}>
              <Card sx={{ height: "100%" }}>
                <CardContent>
                  <Typography variant="h6" gutterBottom>
                    Show Results
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Manage show results for each show
                  </Typography>
                  <Button
                    variant="contained"
                    size="small"
                    sx={{ mt: 2 }}
                    onClick={() => navigate('/admin/showResultsManagement')}
                  >
                    Show Results
                  </Button>
                </CardContent>
              </Card>
            </div>
            <div style={{ width: '100%' }}>
              <Card sx={{ height: "100%" }}>
                <CardContent>
                  <Typography variant="h6" gutterBottom>
                    Standings
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Manage current standings
                  </Typography>
                  <Button
                    variant="contained"
                    size="small"
                    sx={{ mt: 2 }}
                    onClick={() => navigate('/admin/standingsManagement')}
                  >
                    Standings
                  </Button>
                </CardContent>
              </Card>
            </div>
          </div>
        </Paper>
      </Container>
    </>
  );
}
